import { render, staticRenderFns } from "./DetailAd.vue?vue&type=template&id=7a9aceea&scoped=true&"
import script from "./DetailAd.vue?vue&type=script&lang=js&"
export * from "./DetailAd.vue?vue&type=script&lang=js&"
import style0 from "./DetailAd.vue?vue&type=style&index=0&id=7a9aceea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9aceea",
  null
  
)

export default component.exports